import { Link } from "react-router-dom";
import { Instagram, Facebook, ArrowUpRight } from "lucide-react";
import { useLang } from "../../contexts/LanguageContext";

export function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="border-t border-border bg-bone"
    >
      <div className="container-art py-20 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5">
            <Link to="/" className="font-heading text-4xl font-light tracking-tight">
              Gonzaga
            </Link>
            <p className="mt-6 max-w-sm font-body font-light text-foreground/70 leading-relaxed">
              {t.footer.tagline}
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-5">{t.contact.direct}</div>
            <ul className="space-y-3 font-body text-base font-light">
              <li>
                <a
                  href="mailto:piotr@gonzaga.pl"
                  className="link-underline"
                  data-testid="footer-email"
                >
                  piotr@gonzaga.pl
                </a>
              </li>
              <li>
                <a
                  href="tel:+48507530568"
                  className="link-underline"
                  data-testid="footer-phone"
                >
                  +48 507 530 568
                </a>
              </li>
              <li className="text-foreground/70">
                ul. Ratajczaka 44/4, 61-728 Poznań
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="overline mb-5">{t.contact.socials}</div>
            <ul className="space-y-3 font-body text-base font-light">
              <li>
                <a
                  href="https://www.instagram.com/gonzaga_myszkowski/"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 link-underline"
                  data-testid="footer-instagram"
                >
                  <Instagram size={14} strokeWidth={1.4} /> Instagram
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/piotr.g.myszkowski/?locale=pl_PL"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 link-underline"
                  data-testid="footer-facebook"
                >
                  <Facebook size={14} strokeWidth={1.4} /> Facebook
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2 flex md:justify-end">
            <button
              type="button"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              data-testid="back-to-top"
              className="group inline-flex items-center gap-2 text-[12px] uppercase tracking-[0.24em] font-medium text-ink"
            >
              {t.common.backToTop}
              <ArrowUpRight
                size={16}
                strokeWidth={1.4}
                className="transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
              />
            </button>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-border flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs uppercase tracking-[0.22em] text-stone">
            © {year} Piotr Gonzaga Myszkowski — {t.footer.rights}
          </p>
          <p className="text-xs uppercase tracking-[0.22em] text-stone">
            {t.footer.madeIn}
          </p>
        </div>
      </div>
    </footer>
  );
}
